<div class="www-par-cod-det-mod">
  <div class="www-par-cod-det-mod__close">
    <a (click)="closeModal()">x zamknij okno </a>
  </div>
  <div class="www-par-cod-det-mod__col text-center">
    @if (codeDetails().main_photo) {
      <img class="www-par-cod-det-mod__col__img" [src]="codeDetails().main_photo" [alt]="codeDetails().main_photo" />
    }
    @if (codeDetails().code) {
      <div class="mb-3">
        <!-- <h3 class="www-par-cod-det-mod__col__h3 mb-3">KOD OFERTY</h3> -->
        <p class="www-par-cod-det-mod__col__h3 mb-3">
          <strong>{{ codeDetails().code }}</strong>
        </p>
        <button class="www-black-btn" (click)="onCopyToClipboard(); pushLayer(codeDetails().name)">Odbierz kod</button>
      </div>
    }
    @if (codeDetails().description) {
      <div class="www-par-cod-det-mod__col__des" [innerHTML]="codeDetails().description"></div>
    }
    @if (codeDetails().additional_description) {
      <!-- <div class="www-par-cod-det-mod__col__add" [innerHTML]="codeDetails().additional_description"></div> -->
      <a class="www-par-cod-det-mod__col__add" [href]="codeDetails().additional_description" target="_blank">{{
        codeDetails().additional_description
      }}</a>
    }
    @if (codeDetails().valid_until) {
      <p class="text-center www-par-cod-det-mod__col__val">
        WAŻNE DO: {{ codeDetails().valid_until | date: 'dd/MM/yyyy' }}
      </p>
    }
  </div>
</div>
